import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { NgIf } from "@angular/common";
import { EnrollmentType, EnrollmentTypeIntMap } from "../../domain/enums/enrollment-type.enum";
import { Icons } from '../../domain/enums/icons-enums';

@Component({
  selector: 'app-enrollment-type-indicator',
  standalone: true,
  imports: [
    MatIcon,
    NgIf
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
      @switch (enrollmentType){
        @case (EnrollmentType.INDIVIDUAL_BED){
          <span class="row base">
            <mat-icon [svgIcon]="icons.HotelIcon"></mat-icon> B&B / Hotel / Motel
          </span>
        }
        @case (EnrollmentType.PROPERTY_MANAGEMENT){
          <span class="row base ">
            <mat-icon [svgIcon]="icons.HouseIcon"></mat-icon> Property Management Company
          </span>
        }
        @case (EnrollmentType.INDIVIDUAL_OWNER){
          <span class="row base">
            <mat-icon svgIcon="person-icon"></mat-icon> Individual Property Owner
          </span>
        }
        @default {
          <span class="row base">
            <mat-icon>help</mat-icon> {{enrollmentType}}
          </span>
        }
      }
  `,
  styles: `
  .row.base {
    display: flex;
    gap: 5px;
    align-items: center;
  }
    span {
      font-family: Roboto;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.15000000596046448px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }
    mat-icon {
      font-size: 20px;
      height: 20px;
      line-height: 1.4;
      color: #555555;
      
    }
  `
})
export class EnrollmentTypeIndicatorComponent {
  @Input() enrollmentType: EnrollmentType | undefined;
  icons = Icons;
  //TODO: use enrollmentTypes from enum
  protected readonly EnrollmentType = EnrollmentType;
}
